/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Error_Load_ListInputs */



/**
* | output |
* | --- |
* | "Couldn't load tournaments." |
*
* @param {Tournament_Error_Load_ListInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_error_load_list = /** @type {((inputs?: Tournament_Error_Load_ListInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Error_Load_ListInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de charger les tournois.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudieron cargar los torneos.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível carregar os torneios.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile caricare i tornei.")
	return /** @type {LocalizedString} */ ("Couldn't load tournaments.")
});